import React, { useState } from 'react';
import FooterIndustrial from './FooterIndustrial';
import TopNavigation from './TopNavigation';
import FloatingWhatsApp from '../ui/FloatingWhatsApp';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const closeSidebar = () => {
    setSidebarOpen(false);
  };

  return (
    <div className={`app-industrial ${sidebarOpen ? 'sidebar-open' : ''}`}>
      {sidebarOpen && <div className="sidebar-overlay" onClick={closeSidebar}></div>}
      <TopNavigation onClose={closeSidebar} isOpen={sidebarOpen} onToggleSidebar={toggleSidebar} />
      <div className="main-content">
        <main className="industrial-main">
          {children}
        </main>
        <FooterIndustrial />
      </div>
      <FloatingWhatsApp 
        phoneNumber="+573507089584"
        companyName="Junisama Inversiones S.A.S"
        message="Hola, me interesa obtener información sobre los servicios sanitarios portátiles para mi evento."
        businessHours={{ start: 8, end: 18 }}
      />
    </div>
  );
};

export default Layout;